import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Session } from '../../../../core/models/session';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { SessionService } from '../../../../core/services/session.service';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-remove-session',
  templateUrl: './remove-session.component.html',
  styleUrls: ['./remove-session.component.scss']
})
export class RemoveSessionComponent implements OnInit {
  currentLoggedInUser = this.authenticationService.currentUserValue.username;
  available: boolean= false;
  sessions: Session[];
  constructor(
    public _dialog: MatDialogRef<RemoveSessionComponent>,
    private sessionService: SessionService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      initiator: String;
      vmName: String
    }) { }

  ngOnInit(): void {
    this.spinner.show()
    this.loadSessionData()
  }

  loadSessionData() {
    this.sessionService
      //.getAllSessions().subscribe({
      .getAllSessionsForUser(this.currentLoggedInUser).subscribe({
        next: (data) => {
          this.spinner.hide()
          if (data == null) {
            this.available = false;
            return;
          }
          this.sessions = <Session[]>JSON.parse(JSON.stringify(data))
          this.sessions = this.sessions.filter(el => el.vmName == this.data.vmName)
          //this.sessions?.forEach((ses) => {
          //  if (ses.name.startsWith('_')) {
          //    ses.name = "NA" + ses.name;
          //  }
          //  if (!(this.avlVMsForFilter?.includes(ses.vmName))) {
          //    this.avlVMsForFilter.push(ses.vmName);
          //  }
          //  if (!(this.avlUserForFilter.includes(ses.user))) {
          //    this.avlUserForFilter.push(ses.user);
          //  }
          //  if (!(this.avlSessionStatesForFilter.includes(ses.state.substring(3)))) {
          //    this.avlSessionStatesForFilter.push(ses.state.substring(3));
          //  }
          //  this.depList.push(ses.deployment)
          //})
          //this.depList = [...new Set(this.depList)]
          //this.depList.sort();
          //this.avlVMsForFilter.sort();
          //this.avlUserForFilter.sort();
          //this.avlSessionStatesForFilter.sort();
          //this.applyFilter();
          this.available = true;
        }, error: (err) => {
          this.spinner.hide();
          this.available = false;
        }
      });
    this.available = true;
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }


  onClose(val: boolean = false) {
    this._dialog.close(true);
  }

  removeSession(session: Session) {
    let message = `Do you want to remove ${session.user} from ${session.vmName}?`;
    if (session.vmName == null || session.vmName == "") {
      message = `Do you want to remove ${session.user} session?`
    }
    this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      disableClose: false,
      width: '25%',
      data: {
        titleMessage: "Remove Session",
        bodyMessage: message,
        cancelText: "Cancel",
        submitText: "Proceed"
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        this.snackBar.open("Action is in progress.", "Ok", { duration: 5000 });
        setTimeout(x => {
          this.refreshComponent()
        }, 2000)
        let sessionVm = session.vmName;
        if (session.vmName == "" || session.vmName == null) {
          sessionVm = "NA";
        }
        this.sessionService.removeSession(sessionVm.toLowerCase(), session.user.toLowerCase(), session.deployment.toLowerCase(), this.currentLoggedInUser.toLowerCase()).subscribe({
          next: (data: any) => {
            if (data.status == 200) {
              this.snackBar.open(data.actionMessage, 'Ok', { duration: 5000 })
            }
            this.refreshComponent()
            this.loadSessionData();
          },
          error: (err) => {
            if (err?.error?.status == 401 || err?.error?.status == 404) {
              this.snackBar.open("Action can not be performed.", "Ok", { duration: 5000 })
              this.refreshComponent();
            }
          }
        })
      }
    })
  }
}
